import { BackButtonService } from './../../../shared/services/back-button.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { animateFactory } from 'ng2-animate';
import { environment } from '../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService } from '../../../shared/';

import { Paper } from '../../model';
import { CookieNames, BasicRoutes, QustionStatus, Status, ApiEndpoints, OnlineStatus } from '../../constant';

@Component({
  selector: 'app-papers',
  templateUrl: '../views/papers.component.html',
  styleUrls: ['../../../css/papers.component.css', '../../../css/paper-sets.component.css']
  // animations: [animateFactory(400, 90, 'ease-in')]
})
export class PapersComponent implements OnInit {

  /**
   * Importing routs
   */
  public paperPartsUrl: string = BasicRoutes.clientPaperParts;
  public setid: string;
  public papers: Array<Paper> = [];
  public statics: any = [];
  public qustionStatus: Object = QustionStatus;
  public paperSetTitle;
  public pageNumber: number = 1;
  public emptyQustionPapers: boolean = false;
  public isScoral = true;

  constructor(
    private _location: Location,
    private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private backButtonService: BackButtonService,
    private router: Router
  ) { }

  ngOnInit() {

    this.route.params.forEach((params: Params) => {
      this.setid = params['setid'];
      this.cookieManagerService.setCookie(CookieNames.paperSetKey, this.setid, false, 1);
    });

    this.cookieManagerService.setCookie(CookieNames.paperStartStatus, 'false', false, 1);
    this.getPapersInSet();
    // this.getPaperStatics();
    this.paperSetTitle = this.cookieManagerService.getCookie(CookieNames.paperSettitle, false);
    window.scrollTo(0, 0); 
  }

  backClicked() {
    let paperType = this.backButtonService.getPaperType();
    this.router.navigate(['home/exams/' + paperType]);
  }

  getPapersInSet() {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPapers, {
      [ApiEndpoints.setid]: this.setid,
      [ApiEndpoints.pageNumber]: this.pageNumber
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.papers = response.papers;
      this.redirectOnline(this.papers);
      if (this.papers.length === 0) {
        this.emptyQustionPapers = true;
      }
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  // getPaperStatics() {
  //   this.httpClientService.authGet(ApiEndpoints.paperStaticts, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
  //     this.statics = response;
  //   }, error => {
  //     this.ErrorManagerService.setError(error);
  //   });
  // }
  redirectOnline(papers){
    papers.forEach(element => {
      if(element.paperSet.isOnlinePaper && element.clientStatus === OnlineStatus.COMPLETE) {
        this.router.navigate(['/home/exams/online/']);
      }
      else if(element.paperSet.isOnlinePaper && element.clientStatus !== OnlineStatus.COMPLETE){
        this.cookieManagerService.setCookie(CookieNames.paperTitle, '', false, 1);
        this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.ONLINE, false, 1);
        this.cookieManagerService.setCookie(CookieNames.paperSetKey, element.paperSet._id, false, 1);
      }
    });
  }

  onScroll() {
    this.pageNumber += 1;
    if (this.isScoral) {
      this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPapers, {
        [ApiEndpoints.setid]: this.setid,
        [ApiEndpoints.pageNumber]: this.pageNumber
      }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
        if (response.papers.length === 0) {
          this.isScoral = false;
        }
        let newPapers: Array<Paper> = [];
        newPapers = response.papers;

        if (newPapers.length !== 0) {
          response.papers.forEach(element => {
            this.papers.push(element);
          });
        }
      }, error => {
        this.ErrorManagerService.setError(error);
      });
    }
  }

  paperSetRouter(paperId, title) {
    if (status != Status.lock) {
      this.router.navigate(['/home/exams/papers/' + paperId + '/parts']);
      this.cookieManagerService.setCookie(CookieNames.paperId, paperId, false, 1);
    }

    this.cookieManagerService.setCookie(CookieNames.paperTitle, title, false, 1);
    document.body.scrollTop = 0;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/papers.component.ts